export default "__VITE_ASSET__e19da1a6__"